import { IKpiDto, InsertFormulaKpiDto, KpiUsedByDto } from '@/service-proxies/service-proxies.g';
import { sdk } from '@/utils/sdk';

export interface SecondaryKpi extends IKpiDto {
    kpis: InsertFormulaKpiDto[] | undefined;
    kpiUsedBy: KpiUsedByDto;
    runByEngine: boolean;
}

export const MAX_LENGTH_CONFIG = {
    kpiId: 20,
    kpiDesc: 100,
    kpiFormula: 200,
} as const;

export const getInputSelectorOptions = (): Array<{ label: string; value: string }> => [
    {
        label: sdk.translation.uiTranslation.translate('setup.scenario.formulaStepForm.selector.yes') as string,
        value: 'yes',
    },
    {
        label: sdk.translation.uiTranslation.translate('setup.scenario.formulaStepForm.selector.no') as string,
        value: 'no',
    },
];
